module.exports = __webpack_public_path__ + "static/img/sec1-detail01@t.bf69b6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pantos/sec1-detail01@t.png
// module id = CwCj
// module chunks = 0